import { Container } from "reactstrap";
import { Editors, MDEEditor } from "../../../../constants";
import MdeExampleOne from "./MdeExampleOne";
import MdeExampleTwo from "./MdeExampleTwo";
import Breadcrumbs from "../../../../coreComponents/breadcrumbs";

const MdeEditorContainer = () => {
  return (
    <>
      <Breadcrumbs mainTitle={MDEEditor} parent={Editors} />
      <Container fluid>
        <MdeExampleOne />
        <MdeExampleTwo />
      </Container>
    </>
  );
};

export default MdeEditorContainer;
